import { StyleSheet } from 'aphrodite/no-important';
import constants from '../../../constants/styles';

const {
	FLAT_BUTTON_BG_COLOR,
	FLAT_BUTTON_COLOR
} = constants;

let styles = {
	infoHeader: {
		marginBottom: '5px'
	},
	flatButton: {
		backgroundColor: FLAT_BUTTON_BG_COLOR,
		color: FLAT_BUTTON_COLOR,
		':hover': {
			backgroundColor: 'none'
		}
	},
	note: {
		fontSize: '0.75em'
	},
	siteLabelForm: {
		width: '500px'
	}
};

export default StyleSheet.create(styles);


// WEBPACK FOOTER //
// ./src/components/forms/sitelabelsform/SiteLabelsForm.styles.js